import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from "react";
import { arrayOf, bool, objectOf, oneOf, shape, string } from "prop-types";
import { formatValue, mapEnumValuesToLabels } from "../../shared/utils";
import { RULESET_OUTCOMES } from "../../constants";
import RulesetIndicator from "../../shared/components/RulesetIndicator";
import HelpIcon from "./HelpIcon";
var BLOCK = RULESET_OUTCOMES.BLOCK,
    INFORM = RULESET_OUTCOMES.INFORM,
    PREVENT = RULESET_OUTCOMES.PREVENT;
/**
 * Takes a component and some props, returns a React component which is
 * wired up as custom render in Rex. See `RexWrapper.js`
 *
 * @param {Class} Component - React component
 * @returns {Class}
 */

var rexCustomRenderer = function rexCustomRenderer(Component) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(RexCustomRenderer, _React$Component);

    function RexCustomRenderer() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = RexCustomRenderer.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          details = _this$props.details,
          help = _this$props.help,
          id = _this$props.id,
          initialValue = _this$props.initialValue,
          isRequired = _this$props.isRequired,
          label = _this$props.label,
          _this$props$passthrou = _this$props.passthroughProps,
          formSubmitAttempted = _this$props$passthrou.formSubmitAttempted,
          overrideRulesetBlockers = _this$props$passthrou.overrideRulesetBlockers,
          rulesetsById = _this$props$passthrou.rulesetsById,
          columnData = _this$props$passthrou.columnData,
          pristine = _this$props.pristine,
          touched = _this$props.touched,
          type = _this$props.type,
          valid = _this$props.valid,
          validationErrors = _this$props.validationErrors;
      var rulesets = rulesetsById[id] ? rulesetsById[id] : [];
      var hasRulesetPreventers = rulesets.find(function (r) {
        return r.outcome === PREVENT;
      });
      var hasRulesetBlockers = rulesets.find(function (r) {
        return r.outcome === BLOCK;
      });
      var isSubmitButton = type === "submit";
      var showError = // If the field has been touched or a form submission was attempted AND
      // the field is invalid
      (formSubmitAttempted || touched) && !valid || // If there are any rulesets of the type 'block' or 'prevent'
      hasRulesetPreventers || hasRulesetBlockers && !overrideRulesetBlockers;
      var initialValueFormatted = formatValue(initialValue, type, mapEnumValuesToLabels(details));
      var formGroupClasses = [!pristine && !showError && !isSubmitButton ? "bg-warning" : "", showError ? "bg-danger text-danger has-error" : ""].join(" ");
      var columnDataValue = null;

      if (columnData && id in columnData) {
        columnDataValue = columnData[id];
      }

      return /*#__PURE__*/React.createElement("tr", {
        className: formGroupClasses
      }, /*#__PURE__*/React.createElement("td", {
        className: "col-xs-5"
      }, !isSubmitButton && /*#__PURE__*/React.createElement("label", {
        htmlFor: id,
        className: "control-label",
        style: {
          textAlign: "left"
        }
      }, label), help && /*#__PURE__*/React.createElement(HelpIcon, {
        help: help
      })), /*#__PURE__*/React.createElement("td", {
        className: "col-xs-3"
      }, !isSubmitButton && /*#__PURE__*/React.createElement("p", {
        className: "form-control-static"
      }, initialValueFormatted)), columnData && /*#__PURE__*/React.createElement("td", {
        className: "col-xs-2"
      }, !isSubmitButton && columnDataValue && /*#__PURE__*/React.createElement("p", {
        className: "form-control-static"
      }, columnDataValue)), /*#__PURE__*/React.createElement("td", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(Component, this.props), showError && validationErrors ? validationErrors.map(function (_ref) {
        var message = _ref.message;
        return /*#__PURE__*/React.createElement("p", {
          className: "help-block",
          key: message
        }, message);
      }) : "", touched && isRequired && /*#__PURE__*/React.createElement("p", {
        className: "help-block"
      }, "Required"), rulesets.map(function (r) {
        return /*#__PURE__*/React.createElement("p", {
          className: "help-block",
          key: r.rulesetId
        }, r.msg, r.outcome === BLOCK && /*#__PURE__*/React.createElement("sup", null, "\u2020"));
      }), hasRulesetBlockers && /*#__PURE__*/React.createElement("p", {
        className: "help-block"
      }, /*#__PURE__*/React.createElement(RulesetIndicator, null))));
    };

    return RexCustomRenderer;
  }(React.Component), _class.propTypes = {
    details: arrayOf(shape({
      label: string,
      value: string
    })),
    help: string,
    id: string.isRequired,
    initialValue: string.isRequired,
    isRequired: bool.isRequired,
    label: string.isRequired,
    passthroughProps: shape({
      formSubmitAttempted: bool.isRequired,
      overrideRulesetBlockers: bool.isRequired,
      rulesetsById: objectOf(arrayOf(shape({
        msg: string.isRequired,
        outcome: oneOf([BLOCK, INFORM, PREVENT]).isRequired,
        rulesetId: string.isRequired
      })))
    }).isRequired,
    pristine: bool.isRequired,
    touched: bool,
    type: string.isRequired,
    valid: bool.isRequired,
    validationErrors: arrayOf(shape({
      message: string.isRequired
    }))
  }, _temp;
};

export default rexCustomRenderer;